import { combineReducers, configureStore } from "@reduxjs/toolkit";
import zipCoverageReducer from "../zipCoverage/zipCoverageSlice";
import rtsReducer from "../dedicatedDelivery/rtsSlice";
import ratecardReducer from "../ratecard/ratecardSlice";
import clientInvoiceReducer from "../clientInvoice/clientInvoiceSlice";
import storeManifestReducer from "../dedicatedReceiving/storeManifestSlice";
import knowledgehubReducer from "../knowledgehub/knowledgehubSlice";
import loginReducer, { userLogin, userLogout } from "../login/loginSlice"; // Import the userLogout action
import sideBarReducer from "../sidebar/sidebarSlice";
import receivingReducer from "../receiving/receivingSlice";
import returnToStationReducer from "../returnToStation/returnToStationSlice";
import parcelCenterReducer from "../parcelCenter/parcelCenterSlice";
import shipmentReducer from "../shipment/shipmentSlice";
import middleMileReducer from "../middleMile/middleMileSlice";
import eventTypeReducer from "../eventType/eventTypeSlice";
import roleReducer from "../role/roleSlice";
import missingManifestReducer from "../missingManifest/missingManifestSlice";
import clientReducer from "../client/clientSlice";
import userReducer from "../user/userSlice";
import eventReducer from "../event/eventSlice";
import packageReducer from "../package/packageSlice";
import fdpReducer from "../fdp/fdpSlice";
import dashboardReducer from "../dedicatedDelivery/dashboardSlice";
import storeReducer from "../dedicatedDelivery/storeSlice";
import { useDispatch } from "react-redux";
import {
  getRouteSlice,
  persistRouteSlice,
} from "../dedicatedDelivery/routeSlice";

const appReducer = combineReducers({
  login: loginReducer,
  sideBar: sideBarReducer,
  receiving: receivingReducer,
  returnToStation: returnToStationReducer,
  parcelCenter: parcelCenterReducer,
  shipmentList: shipmentReducer,
  middleMile: middleMileReducer,
  eventType: eventTypeReducer,
  role: roleReducer,
  zipCoverage: zipCoverageReducer,
  missingManifest: missingManifestReducer,
  client: clientReducer,
  user: userReducer,
  event: eventReducer,
  package: packageReducer,
  fdp: fdpReducer,
  dedicatedDeliveryDashboard: dashboardReducer,
  dedicatedDeliveryStore: storeReducer,
  dedicatedDeliveryFetchRoute: getRouteSlice.reducer,
  dedicatedDeliveryPersistRoute: persistRouteSlice.reducer,
  rts: rtsReducer,
  ratecard: ratecardReducer,
  clientInvoice: clientInvoiceReducer,
  storeManifest: storeManifestReducer,
  knowledgehub: knowledgehubReducer,
});

const rootReducer = (state: any, action: any) => {
  if (
    action.type === userLogout.fulfilled.type ||
    action.type === userLogin.fulfilled.type
  ) {
    state = undefined; // Reset the state to undefined on logout and on login
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<typeof store.dispatch>();

export default store;
